import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ums-feedback",
  "use": "icon-ums-feedback-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ums-feedback\"><path d=\"M737 512c-33.9 0-61.4-27.5-61.4-61.4s27.5-61.4 61.4-61.4 61.4 27.5 61.4 61.4S770.9 512 737 512m-225 0c-33.9 0-61.4-27.5-61.4-61.4s27.5-61.4 61.4-61.4 61.4 27.5 61.4 61.4S545.9 512 512 512m-225 0c-33.9 0.9-62.1-25.9-62.9-59.7-0.9-33.9 25.9-62.1 59.7-62.9h3.2c33.9 0.9 60.6 29 59.8 62.9-0.9 32.6-27.2 58.8-59.8 59.7M887 62H137c-41.4 0-75 35.1-75 78.3v602.6c0 43.2 33.7 78.3 75.2 78.3h242.1c7.5 0 20 7.3 23.4 13.7l48.7 92 3.7 5.8c14.2 18.5 35 29.2 56.9 29.2s42.7-10.6 57-29.2l52.4-97.9c3.1-5.9 15.3-13.7 23.4-13.7h242.3c41.3 0 74.9-35.1 74.9-78.3V140.3c0-43.2-33.7-78.3-75-78.3\" p-id=\"6130\" fill=\"#b5c5d2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ums-feedback.svg
// module id = uhBA
// module chunks = 59